import { useContext } from 'react';
import { BusinessAccountContext, BusinessAccountContextType } from '@/contexts/BusinessAccountContext';

const DEFAULT_CONTEXT: BusinessAccountContextType = {
  selectedAccountId: null,
  selectedAccount: null,
  setSelectedAccountId: () => {},
  clearSelectedAccount: () => {},
  setWorkspaceAccountOverride: () => {},
  accounts: null,
  isLoading: false,
  isAccountsFetching: false,
  // Outside the provider there is no bridge to wait for, so nothing should
  // ever hold a placeholder open on its account.
  workspaceBridgeSettled: true,
};

export function useBusinessAccountContext(): BusinessAccountContextType {
  const context = useContext(BusinessAccountContext);
  return context ?? DEFAULT_CONTEXT;
}

